import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBubblesBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 120,
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_10863_32520)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M42.8389 81.5571C43.3271 81.3847 43.86 81.6133 44.0762 82.0718L44.1143 82.1665L44.3321 82.7622C46.6355 88.8966 50.7284 94.2046 56.087 97.9927C61.6183 101.903 68.2263 104.001 75.0001 104H105C105.729 104 106.429 103.71 106.944 103.194C107.46 102.678 107.75 101.979 107.75 101.25V71.2495C107.75 62.8742 104.54 54.8169 98.7823 48.7349C93.2041 42.8429 85.6444 39.2382 77.5743 38.6021L76.792 38.5493L76.6905 38.5386C76.1898 38.4599 75.8204 38.0136 75.8487 37.4966C75.877 36.9797 76.2928 36.576 76.7989 36.5522L76.9014 36.5532L77.7315 36.6079C86.2947 37.2829 94.3165 41.1079 100.235 47.3599C106.345 53.8134 109.75 62.3627 109.75 71.2495V101.25C109.75 102.509 109.249 103.718 108.358 104.609C107.468 105.499 106.26 106 105 106H75.0001C67.8127 106.001 60.8017 103.774 54.9327 99.6255C49.2469 95.6061 44.9041 89.9743 42.46 83.4653L42.2295 82.8335L42.2003 82.7349C42.0804 82.2424 42.3508 81.7297 42.8389 81.5571Z",
			fill: "#14151F"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M77.75 48.75C77.75 40.0642 74.3 31.7336 68.1582 25.5918C62.0164 19.45 53.6858 16 45 16C36.3142 16 27.9836 19.45 21.8418 25.5918C15.7 31.7336 12.25 40.0642 12.25 48.75V78.75C12.25 79.4793 12.5399 80.1786 13.0557 80.6943C13.5714 81.2101 14.2707 81.5 15 81.5H45C53.6858 81.5 62.0164 78.05 68.1582 71.9082C74.3 65.7664 77.75 57.4358 77.75 48.75ZM79.75 48.75C79.75 57.9663 76.0892 66.8054 69.5723 73.3223C63.0554 79.8392 54.2163 83.5 45 83.5H15C13.7402 83.5 12.5324 82.9992 11.6416 82.1084C10.7508 81.2176 10.25 80.0098 10.25 78.75V48.75C10.25 39.5337 13.9108 30.6946 20.4277 24.1777C26.9446 17.6608 35.7837 14 45 14C54.2163 14 63.0554 17.6608 69.5723 24.1777C76.0892 30.6946 79.75 39.5337 79.75 48.75Z",
			fill: "url(#paint0_linear_10863_32520)"
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_10863_32520",
		x1: 10.25,
		y1: 83.5,
		x2: 92.1242,
		y2: 62.6938,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#E45D96"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_10863_32520",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 120,
			height: 120,
			fill: "white"
		})
	})] })]
});
export default SvgBubblesBig;
